"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconAliases = _interopRequireDefault(require("icons/iconAliases"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _iconName = require("../utils/propTypes/iconName");

var _IconConstants = require("./IconConstants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font: inherit !important;\n  &::before {\n    content: \"", "\";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sizeToRes = function sizeToRes(size) {
  return size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
};

var getIconClassName = function getIconClassName(size, measuredRes) {
  var res = size != null ? sizeToRes(_IconConstants.ICON_SIZES[size] || size) : measuredRes;
  return "private-icon__" + res;
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return _IconConstants.ICON_SIZES[size];
  }

  return size;
};

var IconContent = _styledComponents.default.span.withConfig({
  displayName: "UIIcon__IconContent",
  componentId: "sc-1ngbkfp-0"
})(_templateObject(), function (_ref) {
  var ligature = _ref.ligature;
  return ligature;
});

var getIconContent = (0, _memoize.default)(function (ligature) {
  return _react.default.createElement(IconContent, {
    "aria-hidden": true,
    ligature: ligature
  });
});
var hasPingedNewRelic = false;
var UIIcon = (0, _memoWithDisplayName.default)('UIIcon', function (props) {
  var className = props.className,
      color = props.color,
      name = props.name,
      screenReaderText = props.screenReaderText,
      style = props.style,
      size = props.size,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "color", "name", "screenReaderText", "style", "size"]);

  var _useState = (0, _react.useState)('low'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      measuredRes = _useState2[0],
      setMeasuredRes = _useState2[1];

  var measureRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (size) return; // Measure the `fontSize` in the DOM to determine whether this is high- or low-res.

    var styles = getComputedStyle(measureRef.current, null); // Patch for Firefox < 62: https://bugzilla.mozilla.org/show_bug.cgi?id=1467722

    if (!styles) return;
    var newMeasuredRes = sizeToRes(parseInt(styles.fontSize, 10));
    if (newMeasuredRes !== measuredRes) setMeasuredRes(newMeasuredRes);
  });

  if (_iconAliases.default[name]) {
    if (window.newrelic && !hasPingedNewRelic) {
      hasPingedNewRelic = true;
      window.newrelic.addPageAction('icon-alias', {
        alias: name
      });
    }

    if (process.env.NODE_ENV !== 'production') {
      _devLogger.default.warn({
        message: "UIIcon: \"" + name + "\" is a deprecated alias. Please use the canonical icon name.",
        key: "UIIcon-" + name,
        url: 'https://tools.hubteamqa.com/ui-library/styles/icons'
      });
    }
  }

  var computedName = _iconAliases.default[name] || name;
  var computedClassName = (0, _classnames.default)('private-icon', getIconClassName(size, measuredRes), className);
  return _react.default.createElement("span", (0, _extends2.default)({}, rest, {
    className: computedClassName,
    "data-icon-name": computedName,
    ref: measureRef,
    style: (0, _extends2.default)({
      color: color
    }, style, {
      fontSize: getComputedFontSize(size)
    })
  }), getIconContent(computedName), screenReaderText && // Spaces around screenReaderText prevents collisions withsiblingtext.
  _react.default.createElement("span", {
    className: "sr-only"
  }, " ", screenReaderText, " "));
});
UIIcon.propTypes = {
  color: _propTypes.default.string,
  name: (0, _iconName.getIconNamePropType)().isRequired,
  screenReaderText: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _propTypes.default.number])
};
var _default = UIIcon;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/icon/UIIcon.js
// module id = 24
// module chunks = 209 210 211 212